import React from "react";
import styled from "styled-components";
import { convertToUpperCase } from "../../utils/helpers/convertToUpperCase";

const ButtonStyles = styled.button`
  background: ${(props) => (props.color ? props.color : "#e6000f")};
  font-weight: 600;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 0.3px;
  border: 0;
  border: ${(props) =>
    props.variant === "inherit" ? "1px solid #e8e9ec" : "0"};
  color: ${(props) => (props.variant === "inherit" ? "black" : "white")};
  outline: 0;
  padding: 8px 0;
  font-size: 12px;
  line-height: 20px;
  width: 100%;
  cursor: pointer;
  max-height: ${(props) => props.height && props.height};
  max-width: ${(props) => (props.width ? props.width : "160px")};
  transition: 0.2s;
  &:hover {
    box-shadow: ${(props) =>
      props.variant === "inherit" || props.variant === "disabled"
        ? "0px 6px 8px #dedede"
        : "0 6px 8px rgb(230 0 15 / 30%)"};
  }
`;

const Button = ({ children, onClick, variant, disabled, ...props }) => {
  const color = () => {
    switch (variant) {
      case "primary": {
        return "#e6000f";
      }
      case "disabled": {
        return "#d5d8e0";
      }
      case "inherit": {
        return "inherit";
      }
      default:
        return "";
    }
  };

  return (
    <ButtonStyles
      onClick={onClick}
      variant={variant}
      color={color()}
      disabled={disabled}
      {...props}
    >
      {convertToUpperCase(children)}
    </ButtonStyles>
  );
};

export default Button;
